/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SelectField from "components/SelectField";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    title: "Sản lượng dầu, khí xuất bản",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    title: "Sản lượng dầu thô, khí thiên nhiên xuất bản quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    title: "Hệ số quy đổi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    unit: "USD",
    title: "Giá bán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    unit: "USD",
    title: "Doanh thu xuất bản trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    unit: "USD",
    title: "Thuế tài nguyên phải nộp trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7",
    unit: "USD",
    title: "Thuế xuất khẩu trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "8",
    unit: "USD",
    title: "Các loại thuế khác (nếu có)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "9",
    unit: "USD",
    title: "Chi phí thu hồi",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "10",
    unit: "USD",
    title: "Chi phí được trừ khác",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "11",
    unit: "USD",
    title: "Lợi nhuận trước thuế [36]=[30]-[31]-...-[35]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "12",
    unit: "%",
    title: "Thuế suất thuế TNDN",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "13",
    unit: "USD",
    title: "Thuế TNDN phải nộp trong kỳ tính thuế [38]=[36]x[37]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "14",
    title: "Lãi dầu, khí sau thuế theo quyết toán [39]=[36]-[38]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "15",
    title: "Tỷ lệ chia cho nước chủ nhà",
    unit: "%",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "16",
    title: "Lãi dầu, khí sau thuế của nước chủ nhà theo quyết toán [41]=[39]x[40]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "17",
    title: "1,5% phí quản lý, giám sát các Hợp đồng dầu khí [42] = [41] - [42]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "18",
    title: "Lãi dầu, khí  nước chủ nhà còn lại theo quyết toán [43] = [41] - [42]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "18.1",
    title: "Tỷ lệ (%) nộp ngân sách",
    unit: "%",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "18.2",
    title: "Tỷ lệ (%) để lại Công ty mẹ - PVN",
    unit: "%",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "18.3",
    unit: "USD",
    title: "Số tiền phải nộp ngân sách theo quyết toán [46] = [43] x [44]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "18.4",
    unit: "USD",
    title: "Số tiền nộp về Công ty mẹ - PVN [47] = [43] x [45]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "19",
    unit: "USD",
    title: "Số tiền lãi dầu, khí tạm tính đã kê khai trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "20",
    unit: "USD",
    title:
      "Chênh lệch giữa số tiền còn phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế [49] = [46] - [48]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "21",
    unit: "VND/USD",
    title: "Tỷ giá quy đổi (nếu có)",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) =>
    ["20", "18.4", "18.3", "18", "17", "16", "14", "13", "11"].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(item.index) ? 800 : 400,
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(item.index) ? 800 : 400,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(item.index) ? 800 : 400,
                  }}
                >
                  [{index + 26}]
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(item.index) ? 800 : 400,
                  }}
                >
                  {!(index + 1 > 4) ? (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({ id: item.id, value: e.target.value, name: "value4" })
                      }
                    >
                      <option value="1">USD</option>
                      <option value="2">VNĐ</option>
                    </select>
                  ) : (
                    item.unit
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(item.index) ? 800 : 400,
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
